import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import styles from "./ConfirmationPop.module.scss";

export const allModels = {
  logout: {
    title: "Do you want to Logout?",
    cancelText: "No",
    confirmText: "Yes",
  },
  delete: {
    title: "Are you sure you want to delete ?",
    cancelText: "No",
    confirmText: "Delete",
  },
};

const ConfirmationPop = ({
  confirmation,
  setConfirmation,
  confirmHandler,
  type,
}) => {
  const hideHandler = () => {
    setConfirmation(false);
  };
  return (
    <>
      <Modal
        show={confirmation}
        className={`${styles.ConfirmationPop} transparentModal`}
        onHide={hideHandler}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className={`${styles.modalBody}`}>
          <div className="px-md-5 text-center mx-auto">
            <h3 className="m-0 fw-bold text-dark">{allModels[type]?.title}</h3>
            <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10">
              <div className="px-2 w-100">
                <button
                  onClick={hideHandler}
                  className="fw-sbold d-flex align-items-center justify-content-center w-100 GreyBtn commonBtn"
                >
                  {allModels[type]?.cancelText}
                </button>
              </div>
              <div className="px-2 w-100">
                <button
                  onClick={confirmHandler}
                  className="fw-sbold d-flex align-items-center justify-content-center commonBtn text-white outline w-100"
                >
                  {allModels[type]?.confirmText}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConfirmationPop;
